import { populateProductUnitImages } from '@core/shopping/utils/productUnit';
/**
 * Fix products structure comming from API
 * to add ext_ids and covert other ids to strings.
 */
/**
 *
 */
export const fixIncomingProducts = (products) => {
    return products.map((product) => {
        // Make sure all ids are strings
        const product_id = String(product.product_id);
        const product_ext_id = String(product.product_ext_id || product.product_id);
        // Remove all images without `image_ext_id` because
        // they are just placeholders created by backend and
        // we wont be able to match them with hydrated products.
        // NOTE:  We might limit this filter to properly integrated
        //        site only.
        const product_images = product.product_images
            // .filter((image) => !!image.image_ext_id)
            .map((image) => {
            return {
                ...image,
                image_id: String(image.image_id),
                image_ext_id: String(image.image_ext_id || image.image_id),
                unit_ids: image.unit_ids ? image.unit_ids.map(String) : [],
                unit_ext_ids: image.unit_ext_ids
                    ? image.unit_ext_ids.map(String)
                    : [],
            };
        });
        const product_units = product.product_units.map((unit) => {
            const unit_ext_id = String(unit.unit_ext_id || unit.unit_id);
            const image = product_images.find((pi) => String(pi.image_id) === String(unit.image_id));
            return {
                ...unit,
                unit_id: String(unit.unit_id),
                unit_ext_id: unit_ext_id,
                product_id: product_id,
                product_ext_id: product_ext_id,
                image_id: image ? String(unit.image_id) : '',
                image_ext_id: image
                    ? String(image?.image_ext_id || image?.image_id)
                    : '',
            };
        });
        return {
            ...product,
            product_id,
            product_ext_id,
            product_images,
            product_units: populateProductUnitImages(product_units, product_images),
        };
    });
};
/**
 *
 */
export const parseUnitOptionsIntoStr = (unit) => {
    if (unit?.unit_options.length) {
        return unit?.unit_options
            .map((o) => Object.values(o))
            .reduce((prev, curr) => [...prev, ...curr], [])
            .join(' / ');
    }
    return '';
};
/**
 *
 */
export const getDefaultUnit = (productUnits) => {
    return productUnits.length
        ? productUnits.slice().sort((a, b) => a.unit_position - b.unit_position)[0]
        : null;
};
/**
 * Returns the external product url on PDP
 */
export const getProductUrl = (product, unit) => unit ? unit.unit_url : product ? product?.product_units[0]?.unit_url : '';
/**
 * Returns the first product from the list
 */
export const getDefaultProduct = (products) => {
    return products[0];
};
